import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import styled from "styled-components";
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, IconButton, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Add } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomerTypeModal from "../../components/modals/CustomerTypeModal";
import ReasonModal from "../../components/modals/ReasonModal";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
  
      `}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;

const TableContainer = styled.div`
  height: calc(
    100vh - ${isMobile ? "56px - 20px - 82.23px" : "100px - 20px - 43.77px"}
  );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;

const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: calc(100% );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

export default function Reason() {

  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [reasonModal, setReasonModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const navigate = useNavigate();

  useEffect(() => {
     getReasonList();
  }, []);

  const  getReasonList = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database. getReasonList();
      console.log("results", results);
  
      const jsonArrayWithId = results?.data?.map((obj) => ({ 
        ...obj, 
        dbId: obj.id
      }));
  
      setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
  };

  const handleDelete = async (data) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this");
    if (!isConfirmed) return;
  
    try {
      setLoading(true);
      await window.Platform.database.deleteReason({ id: data });
      window.NotificationUtils.showSuccess("Delete successfully!");
       getReasonList();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getReasonListColumns = () => [
    {
      field: "Name",
      headerName: "Name",
      width: 700,
      sortable: false,
      valueGetter: (params) => params.row?.name || "N/A",
      renderCell: (params) => (
        <Tooltip title={params.row?.name || "N/A"}>
          <Typography variant="inherit"  sx={{color:"black", fontSize:"14px", fontWeight:"400"}}>{params.row?.name || "N/A"}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      minWidth: 150,
      renderCell: (params) => (
        <>
          <Tooltip title="Update">
            <IconButton onClick={() => handleEdit(params.row)}>
              <DriveFileRenameOutlineIcon sx={{color:"black", fontSize:"22px", fontWeight:"400"}}/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton onClick={() => handleDelete(params.row.dbId)}>
              <DeleteIcon sx={{color:"Red", fontSize:"22px", fontWeight:"400"}}/>
            </IconButton>
          </Tooltip>
        </>
      ),
    }
  ];
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton />
        <GridToolbarFilterButton /> */}
      </GridToolbarContainer>
    );
  }
 const goBack = () => {
    navigate(-1);
  }

  const renderContent = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer>
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={accessChanges || []}
            columns={getReasonListColumns()}
             sx={{color:"black", fontSize:"14px", fontWeight:"600"}}
            rowHeight={60}
            disableSelectionOnClick
            disableRowSelectionOnClick
            autoPageSize
            components={{
              Toolbar: CustomToolbar,
            }}
            pageSizeOptions={[10]}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const addVisit = () => {
    setReasonModal(true);
  }

  const handleEdit = (data) => {
    setEditModal(true);
    setDataModal(data);
  }

  return (
    <>
      {isMobile && (
        <Drawer />
      )}
      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <div>
              <Button variant="outlined" onClick={goBack} sx={{ mb: 2 }}>
             <ArrowBackIcon sx={{marginRight:"2px"}}/> Back
            </Button>
          </div>

          <Stack direction={"row"} spacing={2} >
            <Button variant="contained" color="primary"
              onClick={() => addVisit()} sx={{ mr: 1, borderRadius: '10px' }}>
              <Add sx={{ mr: 1 }} />
              Add New
            </Button>
          </Stack>

        </HeaderContainer>
        <TableContainer>{renderContent()}</TableContainer>
      </StaffEditorPageContainer>
      {
        reasonModal &&
        <ReasonModal
          onClose={() => setReasonModal(false)}
          loading={loading}
          fetchData={() =>  getReasonList()}
          status={true}
        />
      }
      {
        editModal &&
        <ReasonModal
          onClose={() => setEditModal(false)}
          loading={loading}
          fetchData={() =>  getReasonList()}
          status={false}
          propData={dataModal}
        />
      }

    </>
  );
}
